import React, {Component} from 'react';
import {
    Nav,
    NavItem,
    NavbarToggler,
    NavbarBrand,
} from 'reactstrap';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Api} from '../../api';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import {getUsername, getUserRole, getAuthToken, logout} from '../../utils';
import {HamburgerMenuOpen, HamburgerMenuClose, PropyLogoIcon} from '../Common/Icons/Icons'
import Menu from '../Menu'
import './Header.scss';

const COLLAPSE_ANCHOR = 1366;

class Header extends Component {

    state = {
        isUserMenu: false,
        isHamburgerClickable: true,
        username: '',
    };

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.updateUsername();
        // setInterval(() => {this.updateUsername()}, 2000)
    }

    updateUsername() {
        const username = getUsername();
        this.setState({username: username});
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        if (window.innerWidth <= COLLAPSE_ANCHOR) {
            document.body.classList.add('sidebar-hidden');
            this.setState({isHamburgerClickable: false})
        } else {
            document.body.classList.remove('sidebar-hidden');
            this.setState({isHamburgerClickable: true})
        }
    };

    render() {
        const {isUserMenu, username} = this.state;
        const {permissions} = this.props;

        return (
            <header className="app-header header navbar">
                <NavbarBrand onClick={() => this.props.history.push('/')}>
                    TransferSign
                </NavbarBrand>
                <Menu  {...this.props}/>
                <div className="header__username" onClick={this.toggleUserMenu}>
                    {username}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6">
                        <g fill="none" fillRule="evenodd">
                            <path d="M0-2h10V8H0z"/>
                            <path stroke="#FFF" strokeWidth="1.5" d="M1 1.124l3.427 3.427c.27.27.708.27.979 0L8.956 1"/>
                        </g>
                    </svg>
                </div>
                {isUserMenu && <RootCloseWrapper onRootClose={this.toggleUserMenu}>
                    <div className="header__userMenu">
                        <div className="header__userMenu-header-menu-option" onClick={this.handleSignout}>Log out</div>
                    </div>
                </RootCloseWrapper>}
            </header>
        );
    };

    currentAdminUrl = () => {
        return this.props.history.location.pathname.substring(1, 6) === 'admin';
    };

    handleSignout = () => {
        const authToken = getAuthToken();
        logout(this.props.history);
        // Api.deleteReq(`doc-chain/access/oauth/token/${authToken}`, authToken);
    };

    toggleUserMenu = () => {
        this.setState({
            isUserMenu: !this.state.isUserMenu,
        });
    }

    sidebarToggle = (e) => {
        e.preventDefault();
        if (this.state.isHamburgerClickable) document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }
}

function mapStateToProps(state) {
    const {users} = state;
    return {
        permissions: users.permissions,
    };
}

export default connect(mapStateToProps)(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js